import { CartItem } from "modules/cart/types/cart";
import { getTotalAmount } from "./cartUtils";

declare global {
    interface Window{
        dataLayer: Record<string, any>[];
    }
}

export const sendAddToCart = (item:CartItem) => {
    if(!window.dataLayer) window.dataLayer = [];
    const total = getTotalAmount([item]);
    window.dataLayer.push({
        event: "addToCart",
        ecommerce: {
            currencyCode: "CLP",
            value: total,
            items:[{
                item_id: item.id,
                item_name: item.name,
                price: item.price_component.reduce((acc, pc) => acc + pc.price, 0),
                quantity: item.price_component.reduce((acc, pc) => acc + pc.quantity, 0),
            }]
        }
    });
};

export const sendViewCart = (items: CartItem[]) => {
    if(!window.dataLayer) window.dataLayer = [];
    const total = getTotalAmount(items);
    window.dataLayer.push({
        event: "viewCart",
        ecommerce: {
            currencyCode: "CLP",
            value: total,
            items: items.map(item => ({
                item_id: item.id,
                item_name: item.name,
                price: item.price_component.reduce((acc, pc) => acc + pc.price, 0),
                quantity: item.price_component.reduce((acc, pc) => acc + pc.quantity, 0)
            }))
        }
    });
}

export const sendDelCart = (item: CartItem) => {
    if(!window.dataLayer) window.dataLayer = [];
    const total = getTotalAmount([item]);
    window.dataLayer.push({
        event: "delToCart",
        ecommerce: {
            currencyCode: "CLP",
            value: total,
            items:[{
                item_id: item.id,
                item_name: item.name,
                price: item.price_component.reduce((acc, pc) => acc + pc.price, 0),
                quantity: item.price_component.reduce((acc, pc) => acc + pc.quantity, 0),
            }]
        }
    });
}

export const getVisitorId = () => {
    const STORAGE_KEY = 'x_visitor_id';

    try {
        // 1. Intentamos recuperar
        let visitorId = localStorage.getItem(STORAGE_KEY);

        if (visitorId) {
            return visitorId;
        }

        // 2. Generamos nuevo
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            visitorId = crypto.randomUUID();
        } else {
            visitorId = 'v-' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
        }

        // 3. Guardamos
        localStorage.setItem(STORAGE_KEY, visitorId);
        
        return visitorId;

    } catch (e) {
        // 4. Fallback de emergencia:
        // Si localStorage falla (cookies bloqueadas), devolvemos un ID temporal en memoria.
        // Este ID se perderá al refrescar, pero evita que la app falle.
        console.warn('LocalStorage bloqueado, usando ID temporal');
        return 'temp-' + Math.random().toString(36).substring(7);
    }
};